
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"d":"M18.207 7.793a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414l3.293 3.293 6.293-6.293a1 1 0 011.414 0z","clip-rule":"evenodd"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      